import { getSourceStatuses } from '../api/GetHistoricalData';
const requestSourceStatusType = 'REQUEST_SOURCE_STATUSES';
const receiveSourceStatusType = 'RECEIVE_SOURCE_STATUSES';

const initialState = { sourceStatuses: [], isLoading: false };

export const actionCreators = {
    requestSourceStatuses: () => async (dispatch) => {
        let store = window.store;
        if (!store.getState().sourceStatus.isLoading) {
            dispatch({ type: requestSourceStatusType });
            if (store.getState().sourceStatus.sourceStatuses && store.getState().sourceStatus.sourceStatuses.length == 0)
                getSourceStatuses().then(data => {
                    dispatch({ type: receiveSourceStatusType, sourceStatuses: data });
                }).catch(ex => {
                    // todo
                });
            else
                dispatch({ type: receiveSourceStatusType, sourceStatuses: store.getState().sourceStatus.sourceStatuses });
        }
    },
};  

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestSourceStatusType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveSourceStatusType) {
        return {
            ...state,
            ...action,
            isLoading: false
        };
    }

    return state;
};
